import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { fetchKanbanBoardColumnCells, performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { setVehicleProperty } from '../../../Vehicles/actions';

const Container = styled.div``;

       
let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_sleutels_aanvragenComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }


  
  onConfirm(option) {
    
    if (option == 'niet_nodig') {this.props.setProperty(`no_keys_neccesary`, '1', () => this.reset());}


    if (option == 'aangevraagd') {this.props.setProperty(`HOOI_no_keys_done`, '1', () => this.reset());}
    if (option == 'aangevraagd')this.props.setProperty(`HOOI_no_keys_done_date`, todaydate, () => this.reset());

  }
  

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />

        <Well>{this.props.column.label} Voltooid?</Well>
        <ModalControls>
          <Button onClick={() => this.onConfirm('niet_nodig')}>{this.lbl('Niet nodig')}</Button>
          <Button onClick={() => this.onConfirm('aangevraagd')}>{this.lbl('Aangevraagd')}</Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle?.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_sleutels_aanvragenComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setProperty(name, value, callback) {
      dispatch(
        setVehicleProperty(ownProps.cell.vehicle.id, name, value, () => {
          callback();
          dispatch(fetchKanbanBoardColumnCells(ownProps.board_id, ownProps.column.id));
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_sleutels_aanvragen = compose(withConnect, withRouter)(HOOI_sleutels_aanvragenComp);
